var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['radio-button-wrapper', _vm.small && 'radio-button-wrapper--small']},[_c('div',{class:[
      'radio-button',
      _vm.selected && 'radio-button--checked',
      _vm.small && 'radio-button--small',
      _vm.disabled && 'radio-button--disabled' ],on:{"click":_vm.onClickHandler}}),(_vm.selected)?_c('span',{class:['radio-button__check', _vm.small && 'radio-button__check--small']}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }